export enum MediaType {
  IMAGE = 'image',
  VIDEO = 'video',
  ANIMATION = 'animation',
  MODEL = 'model',
}
